"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountryNameByCountryCode = exports.Country = void 0;
var Country;
(function (Country) {
  Country["CANADA"] = "CA";
  Country["CHILE"] = "CL";
  Country["ECUADOR"] = "EC";
  Country["ESTONIA"] = "EE";
  Country["FINLAND"] = "FI";
  Country["ICELAND"] = "IS";
  Country["MEXICO"] = "MX";
  Country["NORWAY"] = "NO";
  Country["PERU"] = "PE";
  Country["SWEDEN"] = "SE";
  Country["USA"] = "US";
  Country["REST_OF_THE_WORLD"] = "ZZ";
})(Country || (exports.Country = Country = {}));
exports.CountryNameByCountryCode = {
  [Country.CANADA]: 'Canada',
  [Country.CHILE]: 'Chile',
  [Country.ECUADOR]: 'Ecuador',
  [Country.ESTONIA]: 'Estonia',
  [Country.FINLAND]: 'Finland',
  [Country.ICELAND]: 'Iceland',
  [Country.MEXICO]: 'Mexico',
  [Country.NORWAY]: 'Norway',
  [Country.PERU]: 'Peru',
  [Country.SWEDEN]: 'Sweden',
  [Country.USA]: 'USA',
  [Country.REST_OF_THE_WORLD]: 'Rest of the world'
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY291bnRyeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9jb3VudHJ5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQVksT0FhWDtBQWJELFdBQVksT0FBTztJQUNmLHdCQUFhLENBQUE7SUFDYix1QkFBWSxDQUFBO0lBQ1oseUJBQWMsQ0FBQTtJQUNkLHlCQUFjLENBQUE7SUFDZCx5QkFBYyxDQUFBO0lBQ2QseUJBQWMsQ0FBQTtJQUNkLHdCQUFhLENBQUE7SUFDYix3QkFBYSxDQUFBO0lBQ2Isc0JBQVcsQ0FBQTtJQUNYLHdCQUFhLENBQUE7SUFDYixxQkFBVSxDQUFBO0lBQ1YsbUNBQXdCLENBQUE7QUFDNUIsQ0FBQyxFQWJXLE9BQU8sdUJBQVAsT0FBTyxRQWFsQjtBQUVZLFFBQUEsd0JBQXdCLEdBQUc7SUFDcEMsQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLEVBQUUsUUFBUTtJQUMxQixDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsRUFBRSxPQUFPO0lBQ3hCLENBQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxFQUFFLFNBQVM7SUFDNUIsQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFDLEVBQUUsU0FBUztJQUM1QixDQUFDLE9BQU8sQ0FBQyxPQUFPLENBQUMsRUFBRSxTQUFTO0lBQzVCLENBQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxFQUFFLFNBQVM7SUFDNUIsQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLEVBQUUsUUFBUTtJQUMxQixDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUMsRUFBRSxRQUFRO0lBQzFCLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxFQUFFLE1BQU07SUFDdEIsQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLEVBQUUsUUFBUTtJQUMxQixDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsRUFBRSxLQUFLO0lBQ3BCLENBQUMsT0FBTyxDQUFDLGlCQUFpQixDQUFDLEVBQUUsbUJBQW1CO0NBQ25ELENBQUEifQ==